import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "src/environments/environment";
import { Plan } from "../models/plan";

@Injectable({
  providedIn: "root"
})
export class PlanService {

    private createHeader() {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          })
        };
        return httpOptions;
      }
    
    constructor(private httpClient: HttpClient) {}

    getOrCreatePlan(userId: string) : Observable<Plan> {
        return this.httpClient.get<Plan>(`${environment.ApiEndpoint}/Plan/GetOrCreateCurrentPlanByUserId?userId=` + userId, this.createHeader());
    }

    getPlan(planId: string) : Observable<Plan> {
      return this.httpClient.get<Plan>(`${environment.ApiEndpoint}/Plan/GetPlanById?planId=` + planId, this.createHeader());
    }

    getEditablePlan(userId: string, year: number) : Observable<Plan> {
      return this.httpClient.get<Plan>(`${environment.ApiEndpoint}/Plan/CreateEditPlanByUserIdAndYear?userId=` + userId + `&year=` + year, this.createHeader())
    }

    getPlans(userId: string) : Observable<Plan[]> {
        return this.httpClient.get<Plan[]>(`${environment.ApiEndpoint}/Plan/GetOrCreateCurrentPlansByUserId?userId=` + userId, this.createHeader());
    }

    submitPlan(plan: Plan) : Observable<Plan> {
      return this.httpClient.post<Plan>(`${environment.ApiEndpoint}/Plan/SubmitPlan`, plan, this.createHeader());
    }

    closeEditPlan(plan: Plan) : Observable<Plan> {
      return this.httpClient.post<Plan>(`${environment.ApiEndpoint}/Plan/CloseEditPlan`, plan, this.createHeader());
    }

    updatePlan(plan: Plan): Observable<Plan> {
      return this.httpClient.put<Plan>(`${environment.ApiEndpoint}/Plan/UpdatePlan`, plan, this.createHeader());
    }
    
    deletePlan(plan: Plan) {
      const httpOptions = {
          headers: new HttpHeaders({
              'Content-Type': 'application/json'
          }),
          body: plan
      };
      return this.httpClient.request('DELETE', `${environment.ApiEndpoint}/Plan/DeletePlan`, httpOptions);
  }
}